export default __webpack_public_path__ + "img/1_2-3129e8f9.png";